module.exports = __webpack_public_path__ + "img/ntd.5f91c719.svg";